import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dynamic-detail-page" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  class: "content-container"
}
const _hoisted_4 = {
  key: 0,
  class: "cover-section"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "main-content" }
const _hoisted_7 = { class: "title-section" }
const _hoisted_8 = { class: "dynamic-title" }
const _hoisted_9 = { class: "dynamic-description" }
const _hoisted_10 = {
  key: 0,
  class: "tags-section"
}
const _hoisted_11 = { class: "meta-info" }
const _hoisted_12 = { class: "meta-item" }
const _hoisted_13 = { class: "meta-item" }
const _hoisted_14 = { class: "meta-item" }
const _hoisted_15 = { class: "content-section" }
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$t('dynamic.detail'),
      "left-arrow": "",
      fixed: "",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, null, 8, ["title"]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_van_loading, {
            size: "24px",
            vertical: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('dynamic.loading')), 1)
            ]),
            _: 1
          })
        ]))
      : ($setup.dynamicData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ($setup.dynamicData.coverPic)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: $setup.dynamicData.coverPic,
                    alt: $setup.dynamicData.title,
                    class: "cover-image",
                    onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleImageLoad && $setup.handleImageLoad(...args))),
                    onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleImageError && $setup.handleImageError(...args)))
                  }, null, 40, _hoisted_5),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "cover-overlay" }, null, -1))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h1", _hoisted_8, _toDisplayString($setup.dynamicData.title), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString($setup.dynamicData.description), 1),
                ($setup.dynamicData.tags && $setup.dynamicData.tags.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dynamicData.tags, (tag) => {
                        return (_openBlock(), _createBlock(_component_van_tag, {
                          key: tag,
                          type: "primary",
                          size: "medium",
                          class: "dynamic-tag"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_van_icon, { name: "user-circle-o" }),
                    _createElementVNode("span", null, _toDisplayString($setup.dynamicData.createdBy), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_van_icon, { name: "clock-o" }),
                    _createElementVNode("span", null, _toDisplayString($setup.formatDate($setup.dynamicData.createdTime)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_van_icon, { name: "eye-o" }),
                    _createElementVNode("span", null, _toDisplayString($setup.dynamicData.readCount) + " " + _toDisplayString(_ctx.$t('dynamic.views')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "dynamic-content",
                  innerHTML: $setup.dynamicData.content
                }, null, 8, _hoisted_16)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}